import React, { useEffect } from "react";
import cl from "./Terms.module.css";
import { animateScroll as scroll } from "react-scroll";

const Terms = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Termini e Condizioni</h1>
      <p>Ultimo aggiornamento: 07 febbraio 2024</p>

      <p>
        Ti preghiamo di leggere attentamente questi termini e condizioni prima
        di utilizzare il Nostro Servizio.
      </p>
      <h2>Interpretazione e Definizioni</h2>
      <h3>Interpretazione</h3>
      <p>
        Le parole con iniziale maiuscola hanno significati definiti nelle
        seguenti condizioni. Le seguenti definizioni avranno lo stesso
        significato indipendentemente dal fatto che compaiano al singolare o al
        plurale.
      </p>
      <h3>Definizioni</h3>
      <p>Per gli scopi di questi Termini e Condizioni:</p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Affiliato</strong> significa un'entità che controlla, è
            controllata o è sotto controllo comune con una parte, dove il
            "controllo" significa il possesso del 50% o più delle azioni,
            interessi patrimoniali o altri titoli aventi diritto di voto per
            l'elezione dei direttori o di altra autorità di gestione.
          </p>
        </li>
        <li>
          <p>
            <strong>Paese</strong> si riferisce a: Arkansas, Stati Uniti
          </p>
        </li>
        <li>
          <p>
            <strong>Società</strong> (indicata anche come &quot;la
            Società&quot;, &quot;Noi&quot;, &quot;Ci&quot; o &quot;Nostro&quot;
            in questo Accordo) si riferisce a {props.shopName}.
          </p>
        </li>
        <li>
          <p>
            <strong>Dispositivo</strong> significa qualsiasi dispositivo che può
            accedere al Servizio come un computer, un cellulare o un tablet
            digitale.
          </p>
        </li>
        <li>
          <p>
            <strong>Servizio</strong> si riferisce al Sito Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Termini e Condizioni</strong> (anche indicati come
            &quot;Termini&quot;) significano questi Termini e Condizioni che
            costituiscono l'intero accordo tra Te e la Società riguardo all'uso
            del Servizio. Questo accordo dei Termini e Condizioni è stato creato
            con l'aiuto del
            <a
              href="https://www.termsfeed.com/terms-conditions-generator/"
              target="_blank"
            >
              Generatore di Termini e Condizioni
            </a>
            .
          </p>
        </li>
        <li>
          <p>
            <strong>Servizio di Social Media di Terze Parti</strong> significa
            qualsiasi servizio o contenuto (incluse dati, informazioni, prodotti
            o servizi) fornito da una terza parte che può essere visualizzato,
            incluso o reso disponibile dal Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Sito Web</strong> si riferisce a {props.shopName},
            accessibile da {props.domain}
          </p>
        </li>
        <li>
          <p>
            <strong>Tu</strong> significa l'individuo che accede o utilizza il
            Servizio, o l'azienda o altra entità giuridica per conto della quale
            tale individuo sta accedendo o utilizzando il Servizio, come
            applicabile.
          </p>
        </li>
      </ul>
      <h2>Riconoscimento</h2>
      <p>
        Questi sono i Termini e le Condizioni che regolano l'uso di questo
        Servizio e l'accordo che intercorre tra Te e la Compagnia. Questi
        Termini e Condizioni stabiliscono i diritti e gli obblighi di tutti gli
        utenti riguardo all'uso del Servizio.
      </p>
      <p>
        Il tuo accesso e l'uso del Servizio sono condizionati all'accettazione e
        al rispetto di questi Termini e Condizioni. Questi Termini e Condizioni
        si applicano a tutti i visitatori, utenti e altre persone che accedono o
        utilizzano il Servizio.
      </p>
      <p>
        Accedendo o utilizzando il Servizio, accetti di essere vincolato da
        questi Termini e Condizioni. Se non sei d'accordo con una parte di
        questi Termini e Condizioni, non potrai accedere al Servizio.
      </p>
      <p>
        Dichiari di avere più di 18 anni. La Compagnia non permette a chi è
        sotto i 18 anni di utilizzare il Servizio.
      </p>
      <p>
        Il tuo accesso e l'uso del Servizio sono anche condizionati
        all'accettazione e al rispetto della Privacy Policy della Compagnia. La
        nostra Privacy Policy descrive le nostre politiche e procedure sulla
        raccolta, l'uso e la divulgazione delle tue informazioni personali
        quando utilizzi l'Applicazione o il Sito Web e ti informa sui tuoi
        diritti in materia di privacy e su come la legge ti protegge. Ti
        preghiamo di leggere attentamente la nostra Privacy Policy prima di
        utilizzare il nostro Servizio.
      </p>
      <h2>Link ad Altri Siti Web</h2>
      <p>
        Il nostro Servizio può contenere link a siti web o servizi di terze
        parti che non sono di proprietà o controllati dalla Compagnia.
      </p>
      <p>
        La Compagnia non ha alcun controllo e non assume alcuna responsabilità
        per i contenuti, le politiche sulla privacy o le pratiche di qualsiasi
        sito web o servizio di terze parti. Riconosci inoltre e accetti che la
        Compagnia non sarà responsabile o responsabile, direttamente o
        indirettamente, per eventuali danni o perdite causati o presumibilmente
        causati dall'uso o dalla dipendenza da tali contenuti, beni o servizi
        disponibili su o tramite tali siti web o servizi.
      </p>
      <p>
        Ti consigliamo vivamente di leggere i termini e le condizioni e la
        privacy policy di qualsiasi sito web o servizio di terze parti che
        visiti.
      </p>
      <h2>Terminazione</h2>
      <p>
        Possiamo terminare o sospendere immediatamente il tuo accesso, senza
        preavviso o responsabilità, per qualsiasi motivo, incluso senza
        limitazioni se violi questi Termini e Condizioni.
      </p>
      <p>
        Alla terminazione, il tuo diritto di utilizzare il Servizio cesserà
        immediatamente.
      </p>
      <h2>Limitazione di Responsabilità</h2>
      <p>
        Senza considerare eventuali danni che Tu potresti subire, l'intera
        responsabilità della Compagnia e di qualunque suo fornitore ai sensi di
        qualsiasi disposizione di questi Termini e la tua esclusiva soluzione
        per tutto quanto precede sarà limitata all'importo effettivamente pagato
        da Te tramite il Servizio o a 100 USD se non hai acquistato nulla
        tramite il Servizio.
      </p>
      <p>
        Nella massima misura consentita dalla legge applicabile, in nessun caso
        la Compagnia o i suoi fornitori saranno responsabili per eventuali danni
        speciali, incidentali, indiretti o consequenziali (inclusi, ma non
        limitati a, danni per perdita di profitti, perdita di dati o di altre
        informazioni, per interruzione dell'attività, per lesioni personali,
        perdita di privacy derivante dall'uso o dall'impossibilità di utilizzare
        il Servizio, software o hardware di terze parti utilizzati con il
        Servizio, o in altro modo in relazione a qualsiasi disposizione di
        questi Termini), anche se la Compagnia o un qualsiasi fornitore fosse
        stato avvisato della possibilità di tali danni e anche se il rimedio
        fallisce nel suo scopo essenziale.
      </p>
      <p>
        Alcuni stati non consentono l'esclusione di garanzie implicite o la
        limitazione di responsabilità per danni incidentali o consequenziali, il
        che significa che alcune delle limitazioni di cui sopra potrebbero non
        essere applicabili. In questi stati, la responsabilità di ciascuna parte
        sarà limitata nella massima misura consentita dalla legge.
      </p>
      <h2>Disclaimer "COME È" e "COME DISPONIBILE"</h2>
      <p>
        Il Servizio ti viene fornito "COME È" e "COME DISPONIBILE" e con tutti i
        difetti e i difetti senza garanzia di alcun tipo. Nella misura massima
        consentita dalla legge applicabile, la Compagnia, per suo conto e per
        conto delle sue Affiliati e dei loro rispettivi licenzianti e fornitori
        di servizi, esclude espressamente tutte le garanzie, siano esse
        esplicite, implicite, legali o di altro tipo, relative al Servizio,
        comprese tutte le garanzie implicite di commerciabilità, idoneità per
        uno scopo particolare, titolo e non violazione, e le garanzie che
        possono derivare dal corso del negozio, dal corso dell'esecuzione,
        dall'uso o dalla pratica commerciale. Senza limitazioni a quanto
        precede, la Compagnia non fornisce alcuna garanzia o impegno, e non fa
        alcuna rappresentazione di alcun tipo che il Servizio soddisferà i tuoi
        requisiti, raggiungerà risultati desiderati, sarà compatibile o
        funzionerà con qualsiasi altro software, applicazioni, sistemi o
        servizi, funzionerà senza interruzioni, soddisferà eventuali standard di
        prestazioni o affidabilità o sarà privo di errori o che eventuali errori
        o difetti potranno o saranno corretti.
      </p>
      <p>
        Senza limitare quanto precede, né la Compagnia né alcun fornitore della
        Compagnia rilascia alcuna rappresentazione o garanzia di alcun tipo,
        esplicita o implicita: (i) riguardo al funzionamento o alla
        disponibilità del Servizio, o delle informazioni, contenuti e materiali
        o prodotti inclusi in esso; (ii) che il Servizio sarà privo di
        interruzioni o errori; (iii) riguardo all'accuratezza, affidabilità o
        attualità di qualsiasi informazione o contenuto fornito tramite il
        Servizio; o (iv) che il Servizio, i suoi server, i contenuti o le e-mail
        inviate da o per conto della Compagnia siano privi di virus, script,
        cavalli di Troia, worm, malware, bombe a orologeria o altri componenti
        dannosi.
      </p>
      <p>
        Alcune giurisdizioni non consentono l'esclusione di determinati tipi di
        garanzie o limitazioni sui diritti statutari applicabili di un
        consumatore, quindi alcune o tutte le esclusioni e limitazioni di cui
        sopra potrebbero non essere applicabili a Te. Ma in tal caso le
        esclusioni e limitazioni stabilite in questa sezione saranno applicate
        nella massima misura consentita dalla legge applicabile.
      </p>
      <h2>Legge Applicabile</h2>
      <p>
        Le leggi del Paese, escludendo le sue norme sulla conflittualità delle
        leggi, regoleranno questi Termini e il tuo utilizzo del Servizio. Il tuo
        utilizzo dell'Applicazione potrebbe anche essere soggetto ad altre leggi
        locali, statali, nazionali o internazionali.
      </p>
      <h2>Risoluzione delle Controversie</h2>
      <p>
        Se hai qualche preoccupazione o controversia riguardo al Servizio,
        accetti di cercare prima di risolvere la controversia informalmente
        contattando la Compagnia.
      </p>
      <h2>Per gli Utenti dell'Unione Europea (UE)</h2>
      <p>
        Se sei un consumatore dell'Unione Europea, beneficerai di qualsiasi
        disposizione obbligatoria della legge del Paese in cui risiedi.
      </p>
      <h2>Conformità Legale degli Stati Uniti</h2>
      <p>
        Dichiari e garantisci che (i) non ti trovi in un Paese soggetto al
        divieto del governo degli Stati Uniti, o che è stato designato dal
        governo degli Stati Uniti come un Paese "sostenitore del terrorismo", e
        (ii) non sei incluso in alcun elenco del governo degli Stati Uniti di
        parti proibite o soggette a restrizioni.
      </p>
      <h2>Divisibilità e Rinuncia</h2>
      <h3>Divisibilità</h3>
      <p>
        Se una disposizione di questi Termini viene ritenuta inapplicabile o
        invalida, tale disposizione verrà modificata e interpretata per
        conseguire gli obiettivi di tale disposizione nella massima misura
        possibile ai sensi della legge applicabile e le disposizioni restanti
        continueranno ad essere in pieno vigore ed effetto.
      </p>
      <h3>Rinuncia</h3>
      <p>
        Salvo diversamente previsto nel presente documento, la mancata
        esercitazione di un diritto o la mancanza di richiesta di adempiere a un
        obbligo ai sensi di questi Termini non pregiudicherà la capacità di una
        parte di esercitare tale diritto o richiedere tale adempimento in
        qualsiasi momento successivo, né la rinuncia a una violazione costituirà
        rinuncia a qualsiasi violazione successiva.
      </p>
      <h2>Interpretazione della Traduzione</h2>
      <p>
        Questi Termini e Condizioni potrebbero essere stati tradotti se li
        abbiamo resi disponibili sul nostro Servizio. Accetti che il testo
        originale in lingua inglese prevarrà in caso di controversia.
      </p>
      <h2>Modifiche a Questi Termini e Condizioni</h2>
      <p>
        Ci riserviamo il diritto, a nostra esclusiva discrezione, di modificare
        o sostituire questi Termini in qualsiasi momento. Se una revisione è
        sostanziale, faremo ragionevoli sforzi per fornire almeno 30 giorni di
        preavviso prima dell'entrata in vigore di eventuali nuovi termini. Cosa
        costituisca una modifica sostanziale sarà determinato a nostra esclusiva
        discrezione.
      </p>
      <p>
        Continuando ad accedere o utilizzare il nostro Servizio dopo che tali
        revisioni sono entrate in vigore, accetti di essere vincolato ai termini
        riveduti. Se non accetti i nuovi termini, in tutto o in parte, ti
        preghiamo di smettere di utilizzare il sito web e il Servizio.
      </p>
      <h2>Contattaci</h2>
      <p>Se hai domande su questi Termini e Condizioni, puoi contattarci:</p>
      <ul style={{ marginLeft: "30px" }}>
        <li>Per email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Terms;
